define('plugin/package/view/PackageModuleItemView',['require','plugin/package/view/PackageItemView','lib/theme/ThemeSettings'],function (require) {

    var PackageItemView = require('plugin/package/view/PackageItemView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Package module item view
     *
     * @class PackageModuleItemView
     */
    return PackageItemView.extend({

        template: '#package_module_item_view',

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#package_module_item_view_list';
            }
            return this.template;
        }

    });

});
